export default __webpack_public_path__ + "static/media/frutiger-65bold.31c9948e.woff";